var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "knd40wud5a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.176471 0 0 0 0 0.423529 0 0 0 0 0.901961 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#knd40wud5a)",
    transform: "translate(-547.000000, -216.000000) translate(531.000000, 208.000000) translate(16.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M17 11.438c0 1.701-.45 3.373-1.302 4.833-.26.447-.83.596-1.274.334-.444-.262-.592-.836-.332-1.283.684-1.173 1.045-2.516 1.045-3.884v-.813c0-.517-.418-.938-.931-.938H2.794c-.513 0-.931.421-.931.938v.813c0 4.238 2.426 7.687 6.637 7.687 1.245 0 2.432-.292 3.527-.867.456-.24 1.02-.062 1.257.397.238.46.061 1.026-.395 1.265C11.544 20.627 10.026 21 8.5 21 3.262 21 0 16.71 0 11.437v-.812c0-1.55 1.253-2.813 2.794-2.813h1.537v-3.22C4.33 2.06 6.42 0 8.988 0h-.022c2.568 0 4.657 2.06 4.657 4.592V8H11.76V4.592c0-1.498-1.254-2.717-2.794-2.717h.022c-1.541 0-2.794 1.22-2.794 2.717v3.22h8.012c1.54 0 2.794 1.262 2.794 2.813v.813zm-8.502 5.78c.515 0 .932-.419.932-.937v-2.055c.477-.309.793-.847.793-1.46 0-.958-.771-1.735-1.723-1.735-.952 0-1.723.777-1.723 1.735 0 .611.315 1.149.79 1.457v2.058c0 .518.417.938.931.938z",
    transform: "translate(3.000000, 1.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.9ed928a394f937f1ed3c6b358aa3700f.svg";
export { ForwardRef as ReactComponent };